import React from "react";
import { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/auth-context";

const PrivateRoute: FC<{ children: any }> = ({ children, ...rest }) => {
  const location = useLocation();
  const { isAuthenticated, authReady } = useAuth();

  // Establishing the session is now a request to the API rather than a synchronous cookie
  // read, so this is a real (if short) wait on every load.
  if (!authReady) return <></>;

  return isAuthenticated ? (
    <>{children}</>
  ) : (
    <Navigate to="/login" state={{ from: location.pathname }} />
  );
};

export default PrivateRoute;
